import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Carousel from "react-slick";

// @material-ui/icons
import FormatQuote from "@material-ui/icons/FormatQuote";
import Star from "@material-ui/icons/Star";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import Muted from "components/Typography/Muted.jsx";
import Warning from "components/Typography/Warning.jsx";
import kendall from "assets/img/faces/kendall.jpg";
import christian from "assets/img/faces/christian.jpg";

import testimonialsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/testimonialsStyle.jsx";

function SectionTestimonialsStateGovernmentNSWDETPage({ ...props }) {
  const { classes, ...rest } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };

  return (
    <div className="cd-section" {...rest}>
      {/*Testimonials 1 START */}
      {/* <div
        className={`${classes.testimonials} ${classes.sectionImage}`}
        style={{
          backgroundImage: `url("https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/caseStudyBackground.jpg")`,
        }}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={6}
              md={6}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>Participant Experiences</h2>
              <h5 className={classes.description}>
                These are what participants who have completed these courses say
              </h5>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <Card testimonial className={classes.card1}>
                <div className={classes.icon}>
                  <FormatQuote />
                </div>
                <CardBody>
                  <h5 className={classes.cardDescription}>
                    As part of my prep for the state interviews I was invited to
                    access “Introduction to Communication Skills & Presentation
                    Skills” by FRANK education. I have been completing them
                    tonight and I am so excited with the skills I am learning
                    and wanted to reach out and say how awesome your training
                    videos are!! I have learnt some very valuable skills that
                    not only will help me in my state award interview, but will
                    also help me in my current career!
                  </h5>
                </CardBody>
                <CardFooter testimonial>
                  <h4 className={classes.cardTitle}>Jono Frost</h4>
                  <h6 className={classes.cardCategory}>
                    Regional Winner, Training NSW 2020 Vocational Student of the
                    Year
                  </h6>
                  <CardAvatar testimonial testimonialFooter>
                    <img
                      src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/lga_logos_mildura.jpeg"
                      alt="Jono Frost testimonial"
                    />
                  </CardAvatar>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card testimonial className={classes.card1}>
                <div className={classes.icon}>
                  <FormatQuote />
                </div>
                <CardBody>
                  <h5 className={classes.cardDescription}>
                    The Frank Team were spot on! They delivered exactly what our
                    group needed and the content responded precisely to our
                    request for service. Our facilitator on the day was young,
                    energetic and engaged really well with the participants.
                  </h5>
                </CardBody>
                <CardFooter testimonial>
                  <h4 className={classes.cardTitle}>Joe Banno</h4>
                  <h6 className={classes.cardCategory}>Inner West Council</h6>
                  <CardAvatar testimonial testimonialFooter>
                    <img
                      src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/lga_logos_innerWest.png"
                      alt="Inner West Council FRANK Team testimonial"
                    />
                  </CardAvatar>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card testimonial className={classes.card1}>
                <div className={classes.icon}>
                  <FormatQuote />
                </div>
                <CardBody>
                  <h5 className={classes.cardDescription}>
                    The session was really enjoyable because it was so
                    interactive.
                  </h5>
                </CardBody>
                <CardFooter testimonial>
                  <h4 className={classes.cardTitle}>Liz Fiveash</h4>
                  <h6 className={classes.cardCategory}>
                    Queensland Government (National Parks Services & Recreation)
                  </h6>
                  <CardAvatar testimonial testimonialFooter>
                    <img
                      src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/lga_logos_qldGovernment.png"
                      alt="Queensland Government FRANK Team testimonial"
                    />
                  </CardAvatar>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div> */}
      {/* Testimonials 1 END
      {/* Testimonials 2 START */}
      <div
        className={`${classes.testimonials} ${classes.sectionDark} ${
          classes.testimonial2
        }`}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={6}
              md={6}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>Client Experience</h2>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Carousel {...settings}>
                <div>
                  <Card testimonial plain className={classes.card2}>
                    <CardAvatar testimonial plain>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/LogosNSWDeptEducation.png"
                          alt="..."
                        />
                      </a>
                    </CardAvatar>
                    <CardBody plain>
                      <h5 className={classes.cardDescription}>
                        Natasha and her team are amazing and understand
                        completely what our business necessities are
                      </h5>
                      <h4 className={classes.cardTitle}>Eduardo Carrera</h4>
                      <Muted>
                        <h6>NSW Department of Education & Training</h6>
                      </Muted>
                    </CardBody>
                    <div>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                    </div>
                  </Card>
                </div>
                {/* <div>
                  <Card testimonial plain className={classes.card2}>
                    <CardAvatar testimonial plain>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img src={christian} alt="..." />
                      </a>
                    </CardAvatar>
                    <CardBody plain>
                      <h5 className={classes.cardDescription}>
                        "Thank you Anna for the invite thank you to the whole
                        Vogue team Called I Miss the Old Kanye At the God's last
                        game Chop up the soul Kanye. I promise I will never let
                        the people down. I want a better life for all!!! Pablo
                        Pablo Pablo Pablo! Thank you Anna for the invite thank
                        you to the whole Vogue team."
                      </h5>
                      <h4 className={classes.cardTitle}>Christian Louboutin</h4>
                      <Muted>
                        <h6>Designer @ Louboutin & Co.</h6>
                      </Muted>
                    </CardBody>
                    <div>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                      <Warning>
                        <Star className={classes.starIcons} />
                      </Warning>
                    </div>
                  </Card>
                </div> */}
              </Carousel>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      {/* Testimonials 2 END */}
    </div>
  );
}

export default withStyles(testimonialsStyle)(
  SectionTestimonialsStateGovernmentNSWDETPage
);
